import { AfterViewInit, Component, ViewChild } from "@angular/core";
import { ITooltipAngularComp } from "ag-grid-angular";
import { ITooltipParams } from "ag-grid-community";
import * as moment from "moment";

@Component({
    selector: 'tooltip-component',
    templateUrl: './tooltip.component.html',
    styleUrls: ['./tooltip.component.scss']
})

export class CustomTooltipComponent implements ITooltipAngularComp, AfterViewInit {
    @ViewChild("mainContainerCustomTooltip") customTooltipContainer;
    @ViewChild("speechContainerCustomTooltip") customTooltipSpeechItemContainer;
    private params!: { color: string } & ITooltipParams;
    public tooltipContent: string = '';
    public data!: any;
    public color!: string;
    public mainContainerCustomTooltip: any;

    constructor() {
    }
    ngAfterViewInit(): void {
        setTimeout(() => {
            const position = this.customTooltipContainer.nativeElement?.getBoundingClientRect();
            const maxWidth = (window.innerWidth - (30 + position.left)) + "px"
            this.customTooltipContainer.nativeElement.style.maxWidth = maxWidth;
            const maxHeight = (window.innerHeight - (50 + position.top)) + "px"
            this.customTooltipContainer.nativeElement.style.maxHeight = maxHeight;
        }, 0)
    }
    agInit(params: { color: string } & ITooltipParams & any): void {
        this.params = params;
        this.data = params.api.getDisplayedRowAtIndex(params.rowIndex!)?.data;
        if (params.isDate) {
            this.tooltipContent = params.format ? moment(params.value).format(params.format) : moment(params.value).utc().format('DD-MM-YYYY h:mm:ss');  
        }
        else {
            this.tooltipContent = this.params.value;
        }
        this.color = this.params.color || 'white';

    }
}